export default __webpack_public_path__ + "static/media/dark21.b97e052b.png";